export enum ExtendedDataType {
    CITY = "city",
    STATE = "state",
    LOCATION = "location",
    PHONE = "phone",
    EMAIL = "email",
    YES_NO = "yes_no"
}
